<template>
  
  <MessageDialogue ref="messageDialogue" />
  <ConfirmDialogue ref="confirmDialogue" />

	<div class="content">
	 

  	<form @submit.prevent="onSubmit($event)">


          <div class="row">
            <div class="col-xs-6 col-sm-6 col-md-6">
              <!-- УО -->
              <div class="form-group disabled">
                <div class="form-control">
                  <label> Наименование организации </label>
                  <input type="text" autocomplete="off" :value="organization.name">
                </div>
              </div>
              <!-- Группа объектов -->
              <div class="form-group" :class="{ 'error': form.district.error.status }">
                <div class="form-control">
                  <label> Название объекта </label>
                  <input type="text"  autocomplete="off" v-model="form.district.value" @focus="form.district.error.status = false;">
                </div>
                <div class="form-error"> {{ form.district.error.message }} </div>
              </div>
              <!-- Год ввода в эксплуатацию -->
              <div class="form-group" :class="{ 'error': form.commissioningYear.error.status }">
                <div class="form-control">
                  <label> Год ввода в эксплуатацию </label>
                  <input type="text"  autocomplete="off" v-model="form.commissioningYear.value" @focus="form.commissioningYear.error.status = false;">
                </div>
                <div class="form-error"> {{ form.commissioningYear.error.message }} </div>
              </div>
              <!-- Ответственное лицо -->
              <div class="form-group" :class="{ 'error': form.manager.error.status }">
                <SelectPicker 
                  :isClear="true"
                  v-model="form.manager.value" 
                  :list="form.manager.list" 
                  label="Ответственное лицо" 
                  @focused="form.manager.error.status = false;" 
                />
                <div class="form-error"> {{ form.manager.error.message }} </div>
              </div>
              <!-- Адрес -->
              <div class="form-group" :class="{ 'error': form.address.error.status }">
                <DadataPicker label="Адрес" :value="form.address.value" type="address" @setValue="setAddress" @focused="form.address.error.status = false;"/>
                <div class="form-error"> {{ form.address.error.message }} </div>
              </div>
              <!-- Группа объектов -->
              <div class="form-group" :class="{ 'error': form.group.error.status }">
                <SelectPicker 
                  :isClear="true"
                  v-model="form.group.value" 
                  :list="form.group.list" 
                  label="Группа объектов" 
                  @focused="form.group.error.status = false;"
                />
                <div class="form-error"> {{ form.group.error.message }} </div>
              </div>


              <!-- Социальный объект -->
              <div class="form-group" :class="{ 'error': form.isSocial.error.status }">
                <div class="switcher">
                  <input id="isSocial" type="checkbox" v-model="form.isSocial.value">
                  <label for="isSocial">Социальный объект</label>
                </div>
              </div>


            </div>
            <div class="col-xs-6 col-sm-6 col-md-6">
              <div class="form-group">
                <ImagePicker v-model="image" />
              </div>
              <!-- Модули -->
              <div class="form-group" :class="{ 'error': form.modules.error.status, 'disabled': user.roleId !== 'admin' }">
                <CheckboxesPicker 
                  v-model="form.modules.value" 
                  :list="form.modules.list" 
                  label="Модули" 
                  @focused="form.modules.error.status = false;" 
                />
                <div class="form-error"> {{ form.modules.error.message }} </div>
              </div>

            </div>
          </div>
          <!-- Кнопки -->
          <div class="btn-group">
            <router-link 
              v-if="house !== null"
              :to="{name: 'PageHouseMain', params: {organization_id: organization.id, house_id: house.id} }" 
              class="btn btn--lg btn--outline">
              <div class="btn--text"> Отменить </div>
            </router-link>
            <router-link 
              v-else
              :to="{name: 'PageOrganization', params: {organization_id: organization.id} }" 
              class="btn btn--lg btn--outline">
              <div class="btn--text"> Отменить </div>
            </router-link>
            <button class="btn btn--lg btn--default" type="submit">
              <div class="btn--text"> Продолжить </div>
              <img class="btn--ico btn--ico--right" src="@/assets/img/next-arrow-white.svg">
              <div class="btn--loader"></div>
            </button>
          </div>
        
    </form>


	</div>
</template>

<script setup>
  import SelectPicker from '@/components/ux/SelectPicker.vue'
  import CheckboxesPicker from '@/components/ux/CheckboxesPicker.vue'
  import ImagePicker from '@/components/ux/ImagePicker.vue'
  import DadataPicker from '@/components/ux/DadataPicker.vue'
  import MessageDialogue from '@/components/modals/MessageDialogue.vue';
  import ConfirmDialogue from '@/components/modals/ConfirmDialogue.vue';
</script>

<script>
  export default {
    name: 'EditForm',
    props: ['organization', 'house'],
  	data: () => ({
      image: null,

      form: {
        isSocial: {
          value: false,
          list: [],
          required: {
            status: true,
            message: '',
          },
          validate: [],
          error: {
            status: false,
            message: null,
          },
        },
        address: {
          value: null,
          params: {
            city: null,
            cityTypeFull: null,
            region: null,
            regionWithType: null,
            timezone: null,
            area: null,
            areaTypeFull: null,
            streetWithType: null,
            houseType: null,
            house: null,
            blockType: null,
            block: null,
          },
          required: {
            status: true,
            message: 'Начните ввод и выберите из списка',
          },
          validate: [
            { regexp: /.{3,}/, msg: 'Минимум 3 символа' }, 
          ],
          error: {
            status: false,
            message: null,
          }
        },
        district: {
          value: null,
          required: {
            status: false,
            message: '',
          },
          validate: [
            { regexp: /.{3,}/, msg: 'Минимум 3 символа' }, 
          ],
          error: {
            status: false,
            message: null,
          }
        },
        commissioningYear: {
          value: null,
          required: {
            status: true,
            message: 'Укажите год',
          },
          validate: [
            { regexp: /^[12][0-9]{3}$/, msg: 'Некорректный год' }, 
          ],
          error: {
            status: false,
            message: null,
          }
        },
        manager: {
          value: null,
          list: [],
          required: {
            status: false,
            message: '',
          },
          validate: [],
          error: {
            status: false,
            message: null,
          }
        },
        group: {
          value: null,
          list: [],
          required: {
            status: false,
            message: '',
          },
          validate: [],
          error: {
            status: false,
            message: null,
          }
        },
        modules: {
          value: [],
          list: [],
          required: {
            status: true,
            message: '',
          },
          validate: [],
          error: {
            status: false,
            message: null,
          }
        },
      }
    }),

    computed: {
      user () {
        return this.$store.state.auth.user;
      },
      modules () {
        return this.$store.state.modules;
      },
      mkdImage () {
        return this.house.imgLinks !== null && this.house.imgLinks.length > 0 ? this.house.imgLinks[0] : null;
      },
    },


    async created () {

      // Форма в режиме редактирования
      if(this.house !== null) {

        // fullAddress должен быть объектом
        if(this.house.fullAddress !== null) {

          // Сразу наполняем данными строчку адреса
          this.form.address.value = this.house.fullAddress.value;

          // Сразу наполняем данными объект адреса
          this.form.address.params.city = this.house.fullAddress.city;
          this.form.address.params.cityTypeFull = this.house.fullAddress.city_type_full;

          this.form.address.params.region = this.house.fullAddress.region;
          this.form.address.params.regionWithType = this.house.fullAddress.region_with_type;
          this.form.address.params.timezone = this.house.fullAddress.timezone;
          this.form.address.params.area = this.house.fullAddress.area;
          this.form.address.params.areaTypeFull = this.house.fullAddress.area_type_full;
          this.form.address.params.streetWithType = this.house.fullAddress.street_with_type;
          this.form.address.params.houseType = this.house.fullAddress.house_type;
          this.form.address.params.house = this.house.fullAddress.house;
          this.form.address.params.blockType = this.house.fullAddress.block_type;
          this.form.address.params.block = this.house.fullAddress.block;

        }

        // Заполняем остальные поля
        this.form.manager.value = this.house.manager ? this.house.manager.id : null;
        this.form.district.value = this.house.district;
        this.form.commissioningYear.value = this.house.commissioningYear;
        this.image = this.mkdImage;
        this.form.isSocial.value = this.house.isSocial;
        this.form.group.value = this.house.houseName ? this.house.houseName.id : null;

        // Проставляем модули
        let modules = [];
        this.house.module.forEach((module) => {
          modules.push(module.num);
        });

        this.form.modules.value = modules;

      }


      // Делаем запросы параллельно
      Promise.all([
        this.$store.dispatch('getModules'),
        this.loadEmployees(),
        this.loadHouseNames(),
      ])
      .then(() => {

        // Ставим список модулей
        for (var key in this.modules) { this.form.modules.list.push({id: key, name: this.modules[key].name }) }
      })
      .catch(() => {})
      .finally(() => {})
    },


    methods: {

        setAddress (item) {

          if(item != null) {
            this.form.address.value = item.value;
            this.form.address.params.city = item.data.city;
            this.form.address.params.cityTypeFull = item.data.city_type_full;
            this.form.address.params.region = item.data.region;
            this.form.address.params.regionWithType = item.data.region_with_type;
            this.form.address.params.timezone = item.data.timezone;
            this.form.address.params.area = item.data.area;
            this.form.address.params.areaTypeFull = item.data.area_type_full;
            this.form.address.params.streetWithType = item.data.street_with_type;
            this.form.address.params.houseType = item.data.house_type;
            this.form.address.params.house = item.data.house;
            this.form.address.params.blockType = item.data.block_type;
            this.form.address.params.block = item.data.block;

            if (this.form.address.params.city == null) {
              this.form.address.params.city = this.form.address.params.region;
            }
            if (this.form.address.params.cityTypeFull == null) {
              this.form.address.params.cityTypeFull = this.form.address.params.regionWithType;
            }

            this.form.group.value = null;

            this.loadHouseNames();

          } else {
            this.form.address.value = null;
            this.form.address.params.city = null;
            this.form.address.params.cityTypeFull = null;
            this.form.address.params.region = null;
            this.form.address.params.regionWithType = null;
            this.form.address.params.timezone = null;
            this.form.address.params.area = null;
            this.form.address.params.areaTypeFull = null;
            this.form.address.params.streetWithType = null;
            this.form.address.params.houseType = null;
            this.form.address.params.house = null;
            this.form.address.params.blockType = null;
            this.form.address.params.block = null;
          }
        },


        // Подгружаем сотрудников организации
        async loadEmployees () {

          const param = new URLSearchParams({});

          param.set("companyId", this.organization.id);
          param.set("roleId", 'director');
          param.set("active", true);
          param.set("detailed", true);

          if(this.house !== null) {
            param.set("houseId", this.house.id);
          }

          let {data} = await this.axios.get(this.$store.state.api_endpoint + '/employees/?' + param);

          this.form.manager.list = data.data;

        },


        async loadHouseNames () {

          const param = new URLSearchParams({});

          param.set("companyId", this.organization.id);
          param.set("cityName", this.form.address.params.city);

          let {data} = await this.axios.get(this.$store.state.api_endpoint + '/houses/houseNames?' + param);

          this.form.group.list = data.data;

        },

 

      	// Создать новый дом
      	async createHouse (param) {
    			const r = await this.axios.post(this.$store.state.api_endpoint + '/houses', param);
        	if(r.status == 200) {
  					return r.data.id;
        	} else {
        	throw new Error('Не удалось создать дом, укажите корректные данные');
        	}
      	},

      	// Обновить информацию о доме
      	async updateHouse (param) {
      		const r = await this.axios.patch(this.$store.state.api_endpoint + '/houses/' + this.house.id, param);
  				if(r.status == 200) {
  					return r.data.id;
        	} else {
        		throw new Error('Не удалось обновить информацию о доме, укажите корректные данные');
        	}
      	},

        // Обновить информацию о подключенных модулях
      	async updateModules (id) {
      		var param = { module: {} };
      		this.form.modules.value.forEach((item) => {
      			param.module[item] = { dateStart: this.$moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'), dateEnd: this.$moment().add(6, 'years').format('YYYY-MM-DDTHH:mm:ss.SSSZ') };
      		});
      		const r = await this.axios.patch(this.$store.state.api_endpoint + '/houses/' + id + '/modules', param);
  				if(r.status !== 200) {
	        	throw new Error('Не удалось обновить информацию о модулях');
          }
      	},

        // Пересобрать меташаблон
      	async updateMetaTemplate (id) {
      		const r = await this.axios.post(this.$store.state.api_endpoint + '/houses/' + id + '/metaTemplate');
  				if(r.status !== 200) {
	        	throw new Error('Не удалось обновить мета шаблон');
          }
      	},



      	async onSubmit (e) {

        	let btn = e.submitter;
        	
        	// Если прошла валидация полей
        	if(!this.$helpers.validateFields(this.form)) { 
            return; 
          }

          // Включаем волчок
          btn.classList.add('btn--load');


        	// Параметры для отправки
        	const param = {
            companyId: this.organization.id,
            city: this.form.address.params.city,
            cityTypeFull: this.form.address.params.cityTypeFull,
            region: this.form.address.params.region,
            regionWithType: this.form.address.params.regionWithType,
            timezone: this.form.address.params.timezone,
            area: this.form.address.params.area,
            areaTypeFull: this.form.address.params.areaTypeFull,
            streetWithType: this.form.address.params.streetWithType,
            houseType: this.form.address.params.houseType,
            house: this.form.address.params.house,
            blockType: this.form.address.params.blockType,
            block: this.form.address.params.block,
            fullAddress: this.form.address.value,
            district: this.form.district.value ? this.form.district.value : '',
            commissioningYear: this.form.commissioningYear.value,
            active: true,
            images: this.image !== null ? [ this.image ] : null,
            managerId: this.form.manager.value,
            isSocial: this.form.isSocial.value,
            houseNameId: this.form.group.value,
	    		}

	        try {

	    			const id = this.house == null ? await this.createHouse(param) : await this.updateHouse(param);

            // Модули + меташаблон обновляет только админ
            
            if(this.user.roleId == 'admin') {
      			  await this.updateModules(id);
      			  await this.updateMetaTemplate(id);
            }

						this.$router.push({name: 'PageHouseEditParam', params: {organization_id: this.organization.id, house_id: id}})

	        } catch (e) {
	        	// На форму падает ошибка
        		this.$refs.messageDialogue.show({message: e.message, okButton: 'Подтвердить'});
	        }
	        
	        // Выключается волчок
	        btn.classList.remove('btn--load');

      	},



    },
  }
</script>

<style scoped>
	.content {
		padding: 25px;
	}
	.btn-group {
		justify-content: space-between;
		margin-top: 20px;
	}
  .form-group:deep(.choose-file) {
    width: 335px;
  }
</style>